/*
 * 功能名称: 功能描述
 * 创 建 人: 程天乐
 * 日    期: 2024-03-06 14:05:26
 */

import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class WorkDeliveryApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'work-delivery';
    }

    /**
    * 保存项目成果
    */
    public SaveWorkDeliveryData(data: any) {
        return this.send(data, "SaveWorkDeliveryData", Methods.POST);
    }


    /**
     * 删除项目成果
     * @param WDId 项目成果Id
     * @returns 
     */
    public DeleteWorkDelivery(WDId: number) {
        return this.send({ WDId }, "DeleteWorkDelivery", Methods.GET);
    }


    /**
     * 获取项目成果列表
     * @param Account 用户账号
     * @param dateTime 日期
     * @returns 
     */
    public GetAmemberADayWorkDelivery(Account: string, dateTime: string, details: boolean = false) {
        return this.send({ Account, dateTime, details }, "GetAmemberADayWorkDelivery", Methods.GET)
    }

    /**
     * 获取完成成果的日期
     * @param Account 用户账号
     * @param dateTime 日期
     * @returns 
     */
    public getHasWorkDeliveryByAccount(userAccount: string, dateTime: string,) {
      return this.send({ userAccount, dateTime }, "getHasWorkDeliveryByAccount", Methods.GET)
    }

    /**
    * 获取当前活动里程碑
    */
    public getProjectUnfinishedWorkCount(){
        return this.send({}, "getProjectUnfinishedWorkCount", Methods.GET);
    }


    /**
     * 获取延期记录
     * @param laneId 
     * @returns 
     */
    public getDelayWorkRecord(laneId: number) {
        return this.send({laneId}, "getDelayWorkRecord", Methods.GET);
    }
}